import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Card from './components/Card';
import { FaLeaf, FaSeedling, FaHandHoldingHeart, FaUsers } from 'react-icons/fa';
import About from './pages/About';
import PrincipesPage from './pages/PrincipesPage';
import Contact from './pages/Contact/Contact.jsx';
import styled, { keyframes } from 'styled-components';
import 'font-awesome/css/font-awesome.min.css';


// Animation pour le sous-titre
const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Composant Home
const Home = () => (
  <div style={styles.homeContainer}>
    <h1 style={styles.pageTitle}>Bienvenue sur CASPH ROYAL</h1>
    <Subtitle>Une coopérative dédiée à l'agriculture durable, la sylviculture et le pastoralisme.</Subtitle>
    <CardsContainer>
      <Card 
        icon={<FaLeaf style={styles.icon} />} 
        title="Agriculture" 
        description="Notre coopérative œuvre pour la promotion de l'agriculture durable et le soutien des agriculteurs locaux."
      />
      <Card 
        icon={<FaSeedling style={styles.icon} />} 
        title="Sylviculture" 
        description="La sylviculture est essentielle pour la gestion des ressources forestières."
      />
      <Card 
        icon={<FaHandHoldingHeart style={styles.icon} />} 
        title="Pastoralisme" 
        description="Le pastoralisme, pilier de la culture traditionnelle, est soutenu par notre coopérative."
      />
      <Card 
        icon={<FaUsers style={styles.icon} />} 
        title="Engagement Communautaire" 
        description="Nous nous engageons à renforcer la solidarité entre les membres de la coopérative."
      />
    </CardsContainer>
  </div>
);

// Composant App
function App() {
  return (
    <Router>
      <div style={styles.container}>
        <Header />
        <Navbar />
        <main style={styles.main}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/principal" element={<PrincipesPage />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

// Styles avec styled-components
const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 20px;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr; 
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  font-weight: normal;
  color: rgb(37, 134, 158);
  margin-top: 10px;
  animation: ${fadeIn} 1.5s ease-in-out;
`;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  main: {
    flex: 1,
    padding: '20px',
    backgroundColor: '#f4f4f4',
  },
  homeContainer: {
    padding: '20px',
    textAlign: 'center',
  },
  pageTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: '20px',
  },
  icon: {
    fontSize: '50px',
    color: '#3498db',
  },
};

export default App;
